<template>
    <TeachersAddTabAccount />
</template>

<script>
import { onUnmounted, provide, ref } from '@vue/composition-api';
import TeachersAddTabAccount from './TeachersAddTabAccount.vue';
import teacherModule from '../teacherModule'
import store from '@/store';
import { getGroups } from '@/composables/groupService';

export default {
    components: { TeachersAddTabAccount },
    setup() {
        const TEACHERS_MODULE = 'teachers'
        const groups = ref([])
        const teacher = ref({
            'name': '',
            'surname': '',
            'address': '',
            'email': '',
            'phone': '',
            'observations': '',
            'groups': [],
            'status': true
        })

        provide('groups', groups)
        provide('teacher', teacher)
        if(!store.hasModule(TEACHERS_MODULE)) store.registerModule(TEACHERS_MODULE, teacherModule)

        onUnmounted(() => {
            if(store.hasModule(TEACHERS_MODULE)) store.unregisterModule(TEACHERS_MODULE)
        })


        const fetchGroups = async function () { groups.value = (await getGroups()).data.groups }
        fetchGroups()

        return {

        }
    }
}
</script>